var prevStartup = __webpack_require__.x;
var hasRun = false;
__webpack_require__.x = () => {
	if (!hasRun) {
	  hasRun = true;
	  __webpack_require__(/*! ./node_modules/@angular-devkit/build-angular/src/tools/babel/webpack-loader.js??ruleSet[1].rules[2].use[0]!./node_modules/@angular-devkit/build-angular/node_modules/source-map-loader/dist/cjs.js??ruleSet[1].rules[3]!./node_modules/.federation/entry.de6d11b268136f5f1ca47a61b3024f22.js */ 66013);
	}
	if (typeof prevStartup === 'function') {
	  return prevStartup();
	} else {
	  console.warn('[Module Federation] prevStartup is not a function, skipping startup execution');
	}
};